import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { HttpclientService } from "../../../shared";
import { DistCalData } from "../calendarmaintenance/DistCalData";
import { SetScheduleRequest } from "./SetScheduleRequest";

@Injectable()
export class AdminSetupService {
	constructor(private httpclientService: HttpclientService) {}

	AcademyList(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/AcademyList?SchoolID=" + SchoolID;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ClassExcuseList(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/ClassExcuseList?SchoolID=" + SchoolID;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ExcuseList(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/ExcuseList?SchoolID=" + SchoolID;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	HomeroomList(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/HomeroomList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DepartmentList() {
		var postResult$ = new Subject();
		var url = "SchoolSetup/DepartmentList";
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SchoolDayList(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/SchoolDayList?SchoolID=" + SchoolID;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
	SchoolDayGet(DayID) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/SchoolDayGet?DayID=" + DayID;

		var promise$ = this.httpclientService.post(url, null);

		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	TimeScanTypeList(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/TimeScanTypeList?SchoolID=" + SchoolID;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GuardianTypeList(SchoolID, Active) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/GuardianTypeList?SchoolID=" + SchoolID + "&Active=" + Active;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
	GuardianInsert(RelationshipCD, RelationshipDesc) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/GuardianInsert?RelationshipCD=" + RelationshipCD + "&RelationshipDesc=" + RelationshipDesc; // + '&DefinedByID=' + DefinedByID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
	GuardianGet(RelationshipID) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/GuardianGet?RelationshipID=" + RelationshipID;

		var promise$ = this.httpclientService.post(url, null);

		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GuardianUpdate(RelationshipID, RelationshipCD, RelationshipDesc) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/GuardianUpdate?RelationshipID=" + RelationshipID + "&RelationshipCD=" + RelationshipCD + "&RelationshipDesc=" + RelationshipDesc;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	FineTypeList(SchoolID, AccountID, UserAssignable) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/FineTypeList?SchoolID=" + SchoolID + "&AccountID=" + AccountID + "&UserAssignable=" + UserAssignable;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
	FineInsert(AccountDebitTypeCD, AccountDebitTypeDesc, AccountID, AccountDebitDefaultAmount, SchoolID) {
		var postResult$ = new Subject();
		var url =
			"SchoolSetup/FineInsert?AccountDebitTypeCD=" +
			AccountDebitTypeCD +
			"&AccountDebitTypeDesc=" +
			AccountDebitTypeDesc +
			"&AccountID=" +
			AccountID +
			"&AccountDebitDefaultAmount=" +
			AccountDebitDefaultAmount +
			"&SchoolID=" +
			SchoolID; // + '&DefinedByID=' + DefinedByID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	FineGet(AccountDebitTypeID) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/FineGet?AccountDebitTypeID=" + AccountDebitTypeID;

		var promise$ = this.httpclientService.post(url, null);

		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
	FineUpdate(AccountDebitTypeID, AccountDebitTypeCD, AccountDebitTypeDesc, AccountDebitDefaultAmount) {
		var postResult$ = new Subject();
		var url =
			"SchoolSetup/FineUpdate?AccountDebitTypeID=" +
			AccountDebitTypeID +
			"&AccountDebitTypeCD=" +
			AccountDebitTypeCD +
			"&AccountDebitTypeDesc=" +
			AccountDebitTypeDesc +
			"&AccountDebitDefaultAmount=" +
			AccountDebitDefaultAmount;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SchoolDayMoveUp(currentschooldayid, PreviousSchoolDayID) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/SchoolDayMoveUp?CurrentSchoolDayID=" + currentschooldayid + "&PreviousSchoolDayID=" + PreviousSchoolDayID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
	SchoolDayMoveDown(currentschooldayid, NextSchoolDayID) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/SchoolDayMoveDown?currentschooldayid=" + currentschooldayid + "&NextSchoolDayID=" + NextSchoolDayID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StaffGetListAcademy(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/StaffGetListAcademy?SchoolID=" + SchoolID;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	SaveAcademy(academy) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/SaveAcademy";
		var promise$ = this.httpclientService.post(url, academy);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	NotificationTypeGetList() {
		var postResult$ = new Subject();
		var url = "SchoolSetup/NotificationTypeGetList";
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	NotificationTypeSelectList(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/NotificationTypeSelectList?SchoolID=" + SchoolID;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	NotificationSchoolInsert(NotificationTypeID, Message, Active, ScheduleTime, SchoolID, NotificationSchoolID) {
		var postResult$ = new Subject();
		var url =
			"SchoolSetup/NotificationSchoolInsert?NotificationTypeID=" +
			NotificationTypeID +
			"&Message=" +
			Message +
			"&Active=" +
			Active +
			"&ScheduleTime=" +
			ScheduleTime +
			"&SchoolID=" +
			SchoolID +
			"&NotificationSchoolID=" +
			NotificationSchoolID;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LanguageTypeGetList() {
		var postResult$ = new Subject();
		var url = "SchoolSetup/LanguageTypeGetList";
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AlertTypeGetList() {
		var postResult$ = new Subject();
		var url = "SchoolSetup/AlertTypeGetList";
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	NotificationSchoolMessageGetList(NotificationTypeID) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/NotificationSchoolMessageGetList?NotificationTypeID=" + NotificationTypeID;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	SaveNotification(notification) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/SaveNotification";
		var promise$ = this.httpclientService.post(url, notification);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AcademyInsert(AcademyCD, AcademyDesc, Director_PersonID, SchoolID) {
		var postResult$ = new Subject();
		var url =
			"SchoolSetup/AcademyInsert?AcademyCD=" +
			AcademyCD +
			"&AcademyDesc=" +
			AcademyDesc +
			"&Director_PersonID=" +
			Director_PersonID +
			"&SchoolID=" +
			SchoolID;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AcademyUpdate(AcademyID, AcademyCD, AcademyDesc, Director_PersonID) {
		var postResult$ = new Subject();
		var url =
			"SchoolSetup/AcademyUpdate?AcademyID=" +
			AcademyID +
			"&AcademyCD=" +
			AcademyCD +
			"&AcademyDesc=" +
			AcademyDesc +
			"&Director_PersonID=" +
			Director_PersonID;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AcademyDelete(AcademyID) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/AcademyDelete?AcademyID=" + AcademyID;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	TimeScanTypeInsert(TimeScanTypeCD, TimeScanTypeDesc, DefinedByID, SchoolID) {
		var postResult$ = new Subject();
		var url =
			"SchoolSetup/TimeScanTypeInsert?TimeScanTypeCD=" +
			TimeScanTypeCD +
			"&TimeScanTypeDesc=" +
			TimeScanTypeDesc +
			"&DefinedByID=" +
			DefinedByID +
			"&SchoolID=" +
			SchoolID;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	TimeScanTypeUpdate(TimeScanTypeID, TimeScanTypeCD, TimeScanTypeDesc) {
		var postResult$ = new Subject();
		var url =
			"SchoolSetup/TimeScanTypeUpdate?TimeScanTypeID=" + TimeScanTypeID + "&TimeScanTypeCD=" + TimeScanTypeCD + "&TimeScanTypeDesc=" + TimeScanTypeDesc;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SaveTimeScanType(timescantype) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/SaveTimeScanType";
		var promise$ = this.httpclientService.post(url, timescantype);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	CourseList() {
		var postResult$ = new Subject();
		var url = "SchoolSetup/CourseList";
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ExcuseDelete(ClassAttendanceExcuseID) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/ExcuseDelete?ClassAttendanceExcuseID=" + ClassAttendanceExcuseID;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ExcuseGet(ClassAttendanceExcuseID) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/ExcuseGet?ClassAttendanceExcuseID=" + ClassAttendanceExcuseID;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ExcuseInsert(ClassAttendanceExcuseCD, ClassAttendanceExcuseDESC) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/ExcuseInsert?ClassAttendanceExcuseCD=" + ClassAttendanceExcuseCD + "&ClassAttendanceExcuseDESC=" + ClassAttendanceExcuseDESC; // + '&DefinedByID=' + DefinedByID;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadSoundList(applicationID, schoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/LoadSoundList?ApplicationID=" + applicationID + "&SchoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GetCalendarFullInfo(StartDate, EndDate, SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/GetCalendarFullInfo?StartDate=" + StartDate + "&EndDate=" + EndDate + "&SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GetCalendarInfo(StartDate, EndDate, SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/GetCalendarInfo?StartDate=" + StartDate + "&EndDate=" + EndDate + "&SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadDayOptions(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/GetDayOptions?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadBellScheduleOptions(SchoolID, Active) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/GetBellScheduleList?SchoolID=" + SchoolID + "&Active=" + Active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	CalendarModifyWithData(parms: DistCalData) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/CalendarModifyWithData";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadCalendarPref(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/LoadCalendarPref?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	TestSchoolCalendarValidity(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/CalendarTestValidity?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	CalendarAdjustment(IsFixed, SkipClosedDay, UseBellSchedule, StartDate, SchoolID, UserID) {
		var postResult$ = new Subject();
		var url =
			"SchoolSetupCalendar/CalendarAdjustment?IsFixed=" +
			IsFixed +
			"&SkipClosedDay=" +
			SkipClosedDay +
			"&UseBellSchedule=" +
			UseBellSchedule +
			"&StartDate=" +
			StartDate +
			"&SchoolID=" +
			SchoolID +
			"&UserID=" +
			UserID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PreferenceUpdateByKeyVal(SchoolID, category, KeyName, KeyVal) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/PreferenceUpdateByKeyVal?SchoolID=" + SchoolID + "&category=" + category + "&KeyName=" + KeyName + "&KeyVal=" + KeyVal;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DistrictSetDefaults(SchoolID, StartDate) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/DistrictSetDefaults?SchoolID=" + SchoolID + "&StartDate=" + StartDate;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
	PeriodGetList(schoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/PeriodGetList?schoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}
	BellScheduleDetailInsert(BellScheduleDesc, SchoolID, PeriodID, StartTime, EndTime, TardyTime) {
		var postResult$ = new Subject();
		var url =
			"SchoolSetup/BellScheduleDetailInsert?BellScheduleDesc=" +
			BellScheduleDesc +
			"&SchoolID=" +
			SchoolID +
			"&PeriodID=" +
			PeriodID +
			"&StartTime=" +
			StartTime +
			"&EndTime=" +
			EndTime +
			"&TardyTime=" +
			TardyTime;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SemesterSelectList(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/SemesterSelectList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	SetSchedule(parms: SetScheduleRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/SetSchedule";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}
}
